import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const setAutobidAPI = async (data, eventId, eventItemId) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}events/${eventId}/item/${eventItemId}/autobid`,
    data,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default setAutobidAPI;
